import React from "react";

const GraphicalReportIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="38.768"
      height="35.122"
      viewBox="0 0 38.768 35.122"
    >
      <g id="db92" transform="translate(-154.691 -175.5)">
        <path
          id="Path_1787"
          data-name="Path 1787"
          d="M154.79,270.13V294a2.965,2.965,0,0,0,2.959,2.967h32.833A2.972,2.972,0,0,0,193.55,294V270.13Zm23.819,3.749a.8.8,0,0,1,.8-.8h4.483a.8.8,0,0,1,.8.8v14.414a.8.8,0,0,1-.8.8h-4.483a.8.8,0,0,1-.8-.8ZM171.127,278a.8.8,0,0,1,.8-.8h4.483a.8.8,0,0,1,.8.8v10.29a.8.8,0,0,1-.8.8h-4.483a.8.8,0,0,1-.8-.8Zm-7.482,3.462a.8.8,0,0,1,.8-.8h4.491a.8.8,0,0,1,.8.8v6.828a.8.8,0,0,1-.8.8h-4.491a.8.8,0,0,1-.8-.8Zm26.18,10.952H158.515a.8.8,0,0,1,0-1.6h31.309a.8.8,0,0,1,0,1.6Z"
          transform="translate(-0.09 -86.342)"
          fill={fill ? fill : "#43e57a"}
        />
        <path
          id="Path_1788"
          data-name="Path 1788"
          d="M274.12,408.68h2.891v5.232H274.12Z"
          transform="translate(-108.969 -212.756)"
          fill={fill ? fill : "#43e57a"}
        />
        <path
          id="Path_1789"
          data-name="Path 1789"
          d="M190.491,175.5H157.658a2.982,2.982,0,0,0-2.967,2.991v3.7h38.768v-3.7a2.983,2.983,0,0,0-2.968-2.991Zm-31.524,4.954h-.112a.8.8,0,1,1,0-1.6h.112a.8.8,0,0,1,0,1.6Zm2.593,0h-.112a.8.8,0,0,1,0-1.6h.112a.8.8,0,0,1,0,1.6Zm2.592,0h-.112a.8.8,0,1,1,0-1.6h.112a.8.8,0,0,1,0,1.6Zm22.845,0h-5.879a.8.8,0,0,1,0-1.6H187a.8.8,0,0,1,0,1.6Z"
          transform="translate(0 0)"
          fill={fill ? fill : "#43e57a"}
        />
        <path
          id="Path_1790"
          data-name="Path 1790"
          d="M359.51,369.16H362.4v8.693H359.51Z"
          transform="translate(-186.879 -176.698)"
          fill={fill ? fill : "#43e57a"}
        />
        <path
          id="Path_1791"
          data-name="Path 1791"
          d="M444.9,322.02h2.891v12.822H444.9Z"
          transform="translate(-264.79 -133.687)"
          fill={fill ? fill : "#43e57a"}
        />
      </g>
    </svg>
  );
};
export default GraphicalReportIcon;
